interface DropzoneError {
  code: string;
  message: string;
}

type MediaType = 'image' | 'video' | 'audio' | 'attachment';

export function TranslateErrorDropzone(error: DropzoneError, mediaType: MediaType = 'video'): string {
  const MAX_SIZE: Record<MediaType, string> = {
    image: '10MB',
    video: '900MB',
    audio: '50MB',
    attachment: '5MB',
  }
  
  const messages: Record<string, string> = {
    'file-too-large': `Seu arquivo é muito grande. Ele precisa ter no máximo ${MAX_SIZE[mediaType]}`,
    'file-invalid-type': 'Esse formato de arquivo não é aceito'
  }

  if(error.code && messages[error.code]){
    return messages[error.code]
  } else {
    return error.message
  }
}